<script setup lang="ts">
interface Props {
  text?: string | null;
}

const { text = null } = defineProps<Props>();
</script>

<template>
  <div class="h-[18px] mt-1 leading-[1.2]">
    <div v-if="text" class="flex items-center gap-1 text-label-small text-on-error-container">
      <svg
        aria-hidden="true"
        class="w-3 h-3 shrink-0"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
      </svg>
      <span class="truncate">{{ text }}</span>
    </div>
  </div>
</template>
